import { getAPIPath, requestDataExportGooseAPI } from '../shared/request'
import { CLIENT_SMS_CONSENT_PATH } from '../types/constants'
import { TSMSConsentRequest, TSMSConsentResponse } from '../types/general'

export const ClientSMSConsentService = {
  updateSMSConsent: async (locationName: string, data: TSMSConsentRequest): Promise<TSMSConsentResponse> => {
    return requestDataExportGooseAPI<TSMSConsentResponse>({
      url: getAPIPath(CLIENT_SMS_CONSENT_PATH, { locationId: locationName }),
      method: 'POST',
      data,
    })
  },
}
